import { Box, TextField, MenuItem, Button, FormControl } from "@mui/material";

export function SitesFilterBar({
  searchText,
  setSearchText,
  filterCompany,
  setFilterCompany,
  filterStatus,
  setFilterStatus,
  companies,
  onSearch,
  onReset,
}) {
  return (
    <Box
      className="filter-container"
      sx={{ display: "flex", gap: 2, mb: 2, pl: 1, flexWrap: "wrap" }}
    >
      <TextField
        label="搜尋地盤"
        size="small"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <FormControl sx={{ minWidth: 150 }}>
        <TextField
          select
          label="KMK子公司"
          size="small"
          value={filterCompany}
          onChange={(e) => setFilterCompany(e.target.value)}
        >
          <MenuItem value="">全部</MenuItem>
          {companies.map((c) => (
            <MenuItem key={c.id} value={c.id}>
              {c.name}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>

      <FormControl sx={{ minWidth: 150 }}>
        <TextField
          select
          label="施工狀態"
          size="small"
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
        >
          <MenuItem value="">全部</MenuItem>
          <MenuItem value="not_start">未動工</MenuItem>
          <MenuItem value="started">施工中</MenuItem>
          <MenuItem value="finished">完工</MenuItem>
          <MenuItem value="delivered">已交付</MenuItem>
        </TextField>
      </FormControl>

      <Button variant="contained" onClick={onSearch}>
        搜尋
      </Button>
      <Button variant="contained" onClick={onReset}>
        重設
      </Button>
    </Box>
  );
}
